import { render, staticRenderFns } from "./QuestEditor.vue?vue&type=template&id=6b228a8c&scoped=true&"
import script from "./QuestEditor.vue?vue&type=script&lang=js&"
export * from "./QuestEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b228a8c",
  null
  
)

export default component.exports